// import {
//   Button,
//   Card,
//   CardContent,
//   Grid,
//   TextField,
//   Typography,
//   Divider,
//   Modal,
//   Box,
//   Table,
//   CircularProgress,
//   LinearProgress,
//   InputAdornment,
// } from "@mui/material";
// import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { useNavigate, useLocation } from "react-router-dom";
// import HOST_URL from "../../../utils/Url";
// import { useFormik } from "formik";
// import * as Yup from "yup";
// import { useTranslation } from "react-i18next";
// import { toast } from "react-toastify";
// import ToastApp from "../../../ToastApp";
// import Autocomplete from "@mui/material/Autocomplete";
// import nopdf from "../../../assets/images/nopdf.png";
// import dayjs from "dayjs";
// import moment from "moment";
// import DeleteIcon from "@mui/icons-material/Delete";
// import AddCircleIcon from "@mui/icons-material/AddCircle";
// import AiIcon from '@mui/icons-material/Psychology';
// import { getSecureDevId } from "../../../utils/storageHelpers";

// const style = {
//   position: "absolute" as "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: "80vw",
//   height: "85vh",
//   bgcolor: "background.paper",
//   border: "1px solid #000",
//   boxShadow: 24,
//   p: 4,
//   borderRadius: "10px",
//   overflowY: 'auto',
// };

// type Props = {};

// interface SelectOption { value: string | number; label: string; }

// const MAX_FILE_SIZE = 50 * 1024 * 1024; // 50MB

// const documentContentKeywords: Record<string, { keywords: string[], typeLabel: string, threshold: number, regex?: RegExp[] }> = {
//   FLEET_VEHICLE_REPORT: {
//     keywords: ["vehicle data", "vehicle no", "vehicle type", "time consumption", "fuel consumpt", "tipper", "dumper", "loader", "skid steer", "tata", "leyland", "truck", "hrs", "mins", "sec", "mt"],
//     regex: [/[A-Z]{2}\s?\d{1,2}\s?[A-Z]{0,3}\s?\/?\s?\d{1,4}/i, /CH\.?NO\.?\s?\d+/i],
//     typeLabel: "Fleet Report / Vehicle Data",
//     threshold: 4
//   },
//   RESUME: { keywords: ["resume", "cv", "curriculum vitae", "experience", "education", "skills", "objective", "summary", "references", "career", "employment history", "qualification"], typeLabel: "Resume/CV", threshold: 2 },
//   INVOICE: { keywords: ["invoice", "bill", "receipt", "amount due", "invoice #", "invoice number", "bill to", "ship to", "item", "quantity", "price", "total", "tax", "vat", "payment terms"], typeLabel: "Invoice/Bill", threshold: 2 },
//   LETTER: { keywords: ["dear", "sincerely", "yours faithfully", "regards", "letter", "correspondence", "enclosed", "subject:", "to whom it may concern"], typeLabel: "Letter/Correspondence", threshold: 2 },
//   NEWS_ARTICLE: { keywords: ["news", "article", "headline", "byline", "published", "edition", "column", "editorial", "reporter", "source", "dateline", "breaking news", "journal"], typeLabel: "News Article/Publication", threshold: 2 },
//   AGREEMENT: { keywords: ["agreement", "contract", "terms and conditions", "party a", "party b", "whereas", "heretofore", "witnesseth", "binding", "legal", "nda", "memorandum of understanding"], typeLabel: "Agreement/Contract", threshold: 2 },
//   REPORT: { keywords: ["report", "summary", "analysis", "findings", "conclusion", "executive summary", "introduction", "methodology", "research", "study", "annual report"], typeLabel: "General Report/Summary", threshold: 2 },
//   FORM: { keywords: ["form", "application", "please fill", "submit", "signature", "date of birth", "personal details", "declaration"], typeLabel: "Form/Application", threshold: 2 },
//   PRESENTATION: { keywords: ["presentation", "slides", "powerpoint", "keynote", "deck", "slide deck"], typeLabel: "Presentation", threshold: 1 },
//   SPREADSHEET: { keywords: ["spreadsheet", "excel", "sheet", "workbook", "data", "table", "csv"], typeLabel: "Spreadsheet/Data", threshold: 1 },
// };

// const simulateAIDocumentTypeDetection = async (
//   _base64Pdf: string,
//   currentFileName: string,
//   t: (key: string, defaultValue?: string) => string
// ): Promise<string | null> => {
//   return new Promise((resolve) => {
//     const contentToAnalyze = currentFileName.toLowerCase().replace(/[_-]/g, " ");
//     console.log("AI Sim: Analyzing content (simulated by filename):", contentToAnalyze);

//     setTimeout(() => {
//       let detectedTypeLabel: string | null = null;
//       let bestMatchScore = 0;
//       let bestMatchKey: string | null = null;

//       for (const docKey in documentContentKeywords) {
//         const { keywords, threshold, regex } = documentContentKeywords[docKey];
//         let currentScore = 0;

//         if (regex && regex.length > 0) {
//           for (const r of regex) {
//             if (r.test(contentToAnalyze)) { currentScore += 3; console.log(`AI Sim: Regex match for ${docKey}`); break; }
//           }
//         }
//         for (const keyword of keywords) {
//           if (contentToAnalyze.includes(keyword)) { currentScore++; if (docKey.toLowerCase().replace(/_/g, " ").includes(keyword.split(" ")[0])) { currentScore += 1; } }
//         }
//         if (currentScore >= threshold && currentScore > bestMatchScore) { bestMatchScore = currentScore; bestMatchKey = docKey; }
//       }

//       if (bestMatchKey) {
//         detectedTypeLabel = documentContentKeywords[bestMatchKey].typeLabel;
//         if (bestMatchKey === "FLEET_VEHICLE_REPORT" && contentToAnalyze.includes("fuel consum")) {
//           detectedTypeLabel = t("text.aiFleetFuelReport", "Fleet Report / Vehicle Fuel Data");
//         }
//         console.log(`AI Sim: Detected as "${detectedTypeLabel}" (from ${bestMatchKey}) for "${currentFileName}" (score: ${bestMatchScore}).`);
//       } else {
//         if (currentFileName.toLowerCase().endsWith(".pdf")) { detectedTypeLabel = t("text.aiGenericDocument", "Generic Document"); }
//         else { console.log(t("text.aiNoSpecificType", "AI could not determine a specific category for this attachment: ") + currentFileName); }
//       }
//       resolve(detectedTypeLabel);
//     }, 1500);
//   });
// };

// // Function to validate file type and extension
// const isValidFileType = (file: File): boolean => {
//   const allowedMimeTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg'];
//   const allowedExtensions = ['.pdf', '.jpeg', '.jpg', '.png'];

//   const fileName = file.name.toLowerCase();
//   const extensionCount = (fileName.match(/\./g) || []).length;

//   if (extensionCount > 1) {
//     console.log("Rejected: Double extension detected");
//     return false;
//   }

//   const fileExtension = fileName.substring(fileName.lastIndexOf('.'));
//   if (!allowedExtensions.includes(fileExtension)) {
//     console.log("Rejected: Invalid file extension");
//     return false;
//   }

//   if (!allowedMimeTypes.includes(file.type)) {
//     console.log("Rejected: Invalid MIME type");
//     return false;
//   }

//   if (file.type === 'application/x-msdownload' ||
//     file.type === 'application/x-dosexec' ||
//     file.type === 'application/x-executable' ||
//     file.name.endsWith('.exe') ||
//     file.name.endsWith('.bat') ||
//     file.name.endsWith('.cmd') ||
//     file.name.endsWith('.sh')) {
//     console.log("Rejected: Executable file detected");
//     return false;
//   }

//   return true;
// };

// // Helper function to format file size
// const formatFileSize = (bytes: number): string => {
//   if (bytes === 0) return '0 Bytes';
//   const k = 1024;
//   const sizes = ['Bytes', 'KB', 'MB', 'GB'];
//   const i = Math.floor(Math.log(bytes) / Math.log(k));
//   return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
// };

// const DocumentEntryEdit = (props: Props) => {
//   var someDate = new Date();
//   var date = someDate.setDate(someDate.getDate());
//   var defaultValues = new Date(date).toISOString().split("T")[0];

//   const today = moment().format("YYYY-MM-DD");

//   const { i18n, t } = useTranslation();

//   // ======================== STATES ========================
//   const [TypeOption, setTypeOption] = useState<SelectOption[]>([]);
//   const [Subject, setSubject] = useState<SelectOption[]>([]);
//   const [Division, setDivision] = useState<SelectOption[]>([]);
//   const [subDepartments, setSubDepartments] = useState<SelectOption[]>([]);
//   const [userRole, setUserRole] = useState<string>("");
//   const [currentDeptId, setCurrentDeptId] = useState<number>(-1);

//   const [Opens, setOpen] = React.useState(false);
//   const [Img, setImg] = useState<any>("");
//   const [loader, setLoader] = useState(false);

//   const [tableData, setTableData] = useState<any>([]);
//   const [pDate, setPDate] = useState(today || "");
//   const [keywords, setKeywords] = useState("");
//   const [fileName, setfileName] = useState("");
//   const [previewUrl, setPreviewUrl] = useState("");
//   const [fileNameWithoutExt, setFileNameWithoutExt] = useState("");
//   const [originalExtension, setOriginalExtension] = useState("");
//   const [pdfBase64, setPdfBase64] = useState("");
//   const [isDetectingAttachmentType, setIsDetectingAttachmentType] = useState(false);
//   const [currentAttachmentAiSuggestion, setCurrentAttachmentAiSuggestion] = useState<string | null>(null);

//   const handlePanClose1 = () => {
//     setOpen(false);
//   };
//   const modalOpenHandle1 = (event: any) => {
//     setOpen(true);
//     setImg(event);
//   };

//   const devId = getSecureDevId();
//   // ✅ FIX: Remove string comparison
//   const initialDivisionId = devId === null || devId === undefined ? "" : Number(devId);

//   let navigate = useNavigate();
//   const location = useLocation();

//   // ======================== FORMIK (PEHLE DEFINE KAREIN) ========================
  
//   const validationSchema = Yup.object({
//     fileNo: Yup.string().required(t("text.reqFileNo", "File No is required")),
//     subsubjId: Yup.string()
//       .nullable()
//       .required(t("text.reqsubsubjId", "Subject is required")),
//     divisionid: Yup.string()
//       .nullable()
//       .required(t("text.reqdivisionid", "Division is required")),
//     fileTypId: Yup.string()
//       .nullable()
//       .required(t("text.reqfileTypeID", "File Type is required")),
//     synopsis: Yup.string().required(
//       t("text.reqFileName", "File Name/Synopsis is required")
//     ),
//     member_DocFiles: Yup.array()
//       .min(1, t("text.reqAttachment", "At least one attachment is required"))
//       .required(t("text.reqAttachment", "Attachment is required")),
//     // subDeptID is OPTIONAL - removed from validation
//   });

//   const formik = useFormik({
//     initialValues: {
//       docMid: location.state?.docMid || "",
//       fileDef: location.state?.fileDef || "",
//       fileNo: location.state?.fileNo || "",
//       synopsis: location.state?.synopsis || "",
//       status: location.state?.status || "",
//       fileType: location.state?.fileType || "",
//       subj: location.state?.subj || "",
//       complt: location.state?.complt || "",
//       fDate: location.state?.fDate ? dayjs(location.state.fDate).format("YYYY-MM-DD") : today,
//       partNo: location.state?.partNo || "",
//       pFileNo: location.state?.pFileNo ? dayjs(location.state.pFileNo).format("YYYY-MM-DD") : today,
//       perFr: location.state?.perFr ? dayjs(location.state.perFr).format("YYYY-MM-DD") : today,
//       perUt: location.state?.perUt ? dayjs(location.state.perUt).format("YYYY-MM-DD") : today,
//       authPersn: location.state?.authPersn || "",
//       fileTypId: location.state?.fileTypId ? String(location.state.fileTypId) : null,
//       subsubjId: location.state?.subsubjId ? String(location.state.subsubjId) : null,
//       sub_Subject_Name: location.state?.sub_Subject_Name || "",
//       divisionid: location.state?.divisionid ? String(location.state.divisionid) : null,
//       subDeptID: location.state?.subDeptID ? String(location.state.subDeptID) : null,
//       createdate: location.state?.createdate || today,
//       user_Id: location.state?.user_Id || 1,
//       userId: location.state?.userId || "",
//       member_DocFiles: [],
//     },
//     validationSchema: validationSchema,
//     onSubmit: async (values) => {
//       setLoader(true);
//       values.member_DocFiles = tableData;
//       console.log("Before submission formik values", values);

//       try {
//         const response = await axios.post(
//           HOST_URL.HOST_URL2 + `DocMangr/AddUpdateDocMangr`,
//           values
//         );
//         if (response.data.isSuccess) {
//           toast.success(response.data.mesg);
//           setLoader(false);
//           setTimeout(() => navigate("/DocManagement/DocumentEntry"), 1000);
//         } else {
//           toast.error(response.data.mesg);
//           setLoader(false);
//         }
//       } catch (error) {
//         console.error("Error submitting form:", error);
//         toast.error(t("text.ErrorSubmittingForm"));
//         setLoader(false);
//       }
//     },
//   });

//   // ======================== FUNCTIONS ========================

//   const getFileType = (deptId: number = -1) => {
//     const collectData = {
//       docID: -1,
//       parentDocId: deptId,
//       userId: "",
//     };
//     axios
//       .post(HOST_URL.HOST_URL2 + `OtherDocType/GetOtherDocType`, collectData)
//       .then((res) => {
//         const arr: SelectOption[] = res?.data?.data?.map((item: any) => ({
//           label: item.doc_Name,
//           value: String(item.docID),
//         })) || [];
//         setTypeOption(arr);
//       })
//       .catch((error) => {
//         console.error("Error fetching file types:", error);
//         toast.error(t("text.ErrorFetchingFileTypes"));
//       });
//   };

//   const getSubject = () => {
//     const collectData = {
//       sID: -1,
//     };
//     axios
//       .post(
//         HOST_URL.HOST_URL2 + `SubjectMasterForPdf/GetSubjectMasterForPdf`,
//         collectData
//       )
//       .then((res) => {
//         const arr: SelectOption[] = res.data.data.map((item: any) => ({
//           label: item.subject,
//           value: String(item.sId),
//         })) || [];
//         setSubject(arr);
//       })
//       .catch((error) => {
//         console.error("Error fetching subjects:", error);
//         toast.error(t("text.ErrorFetchingSubjects"));
//       });
//   };

//   const getDivision = () => {
//     const collectData = {
//       id: initialDivisionId === "" ? -1 : initialDivisionId,
//       nodeID: -1,
//       titleID: -1,
//     };
//     axios
//       .post(HOST_URL.HOST_URL2 + `NewNodeMaster/GetNewNodeMaster`, collectData)
//       .then((res) => {
//         const arr: SelectOption[] = res.data.data.map((item: any) => ({
//           label: item.name,
//           value: String(item.id),
//         })) || [];
//         setDivision(arr);

//         // Auto-select division if secure devId is present
//         const secureDevId = getSecureDevId();
//         if (secureDevId !== -1 && secureDevId !== null && secureDevId !== undefined) {
//           const found = arr.find(opt => Number(opt.value) === Number(secureDevId));
//           if (found) {
//             formik.setFieldValue("divisionid", String(found.value));
//             getSubDepartment(Number(found.value));
//           }
//         }
//       })
//       .catch((error) => {
//         console.error("Error fetching divisions:", error);
//         toast.error(t("text.ErrorFetchingDivisions"));
//       });
//   };

//   const getSubDepartment = (deptId: number = -1, subDeptId: number = -1) => {
//     const collectData = {
//       "subDeptID": subDeptId,
//       "deptID": deptId
//     };
//     axios
//       .post(HOST_URL.HOST_URL2 + `SubDepartmentMaster/GetSubDepartmentMaster`, collectData)
//       .then((res) => {
//         const arr: SelectOption[] =
//           res.data.data.map((item: any) => ({
//             label: item.subDeptName,
//             value: String(item.subDeptID),
//           })) || [];
//         setSubDepartments(arr);
//       })
//       .catch((error) => {
//         console.error("Error fetching sub departments:", error);
//         toast.error(t("text.ErrorFetchingDivisions"));
//       });
//   };

//   const getDocManagerbyID = async () => {
//     const collectData = {
//       docMid: location.state?.docMid || -1,
//       fileTypId: -1,
//       divisionid: -1,
//       subsubjId: -1,
//       user_Id: -1,
//       fileNo: "",
//       subDeptID: -1,
//       synopsis: "",
//       complt: ""
//     };
//     await axios
//       .post(HOST_URL.HOST_URL2 + `DocMangr/GetDocMangr`, collectData)
//       .then((res) => {
//         var member_DocFiles;
//         for (let index = 0; index < res.data.data?.length; index++) {
//           member_DocFiles = res.data.data[index]["member_DocFiles"];
//           const arrtabledata = [];
//           for (let index = 0; index < member_DocFiles?.length; index++) {
//             arrtabledata.push({
//               id: index + 1,
//               pdFid: member_DocFiles[index]["pdFid"] || "",
//               pdfName: member_DocFiles[index]["pdfName"] || "",
//               docMid: member_DocFiles[index]["docMid"] || "",
//               keywords: member_DocFiles[index]["keywords"] || "",
//               subFtype: member_DocFiles[index]["subFtype"] || "",
//               pDate: moment(member_DocFiles[index]["pDate"] || "").format(
//                 "YYYY-MM-DD"
//               ),
//               isMain: member_DocFiles[index]["isMain"] || "",
//               entryDate: member_DocFiles[index]["entryDate"] || "",
//               user_id: member_DocFiles[index]["user_id"] || "",
//               pdfPath: member_DocFiles[index]["pdfPath"] || "",
//               pdfView: member_DocFiles[index]["pdfPath"] || "",
//               srn: -1,
//               isDelete: member_DocFiles[index]["isDelete"] || "",
//             });
//           }
//           setTableData(arrtabledata);
//           console.log("arrtableData", arrtabledata)
//         }
//       });
//   };

//   // ======================== USEEFFECTS (FORM KE BAAD) ========================

//   // Get user role and department on load
//   useEffect(() => {
//     let userRoleLocal = "";
//     let userDeptId = -1;
//     let userSubDeptId = -1;

//     try {
//       const userData = JSON.parse(localStorage.getItem("userdetail") || "[]");
//       if (userData && userData.length > 0) {
//         const user = userData[0];
//         userRoleLocal = user.roleName || user.role || "";
//         userDeptId = user.deptId || user.departmentId || user.empDeptId || -1;
//         userSubDeptId = user.subDeptId || user.subDepartmentId || user.empSubDeptId || -1;

//         setUserRole(userRoleLocal);
//         setCurrentDeptId(userDeptId);
//       }
//     } catch (error) {
//       console.error("Error getting user data:", error);
//     }

//     const isAdmin = userRoleLocal?.toLowerCase() === "admin" ||
//       userRoleLocal?.toLowerCase() === "administrator";

//     const filterDeptId = isAdmin ? -1 : userDeptId;
//     const filterSubDeptId = isAdmin ? -1 : userSubDeptId;

//     getFileType(filterDeptId);
//     getSubject();
//     getDivision();
//     getSubDepartment(userDeptId, filterSubDeptId);
//     getDocManagerbyID();
//   }, []);

//   // ✅ When department changes, update file types and sub-departments
//   useEffect(() => {
//     if (formik.values.divisionid) {
//       const deptId = Number(formik.values.divisionid);
//       const isAdmin = userRole?.toLowerCase() === "admin" ||
//         userRole?.toLowerCase() === "administrator";

//       const filterDeptId = isAdmin ? -1 : deptId;
//       getFileType(filterDeptId);

//       const filterSubDeptId = isAdmin ? -1 : currentDeptId;
//       getSubDepartment(deptId, filterSubDeptId);
//     }
//   }, [formik.values.divisionid, userRole]);

//   // ======================== EVENT HANDLERS ========================

//   const onTransctionChange = async (event: any) => {
//     event.preventDefault();
//     if (event.target.files && event.target.files[0]) {
//       const file = event.target.files[0];

//       // ========== FILE SIZE VALIDATION ==========
//       if (file.size > MAX_FILE_SIZE) {
//         const fileSizeInMB = (file.size / (1024 * 1024)).toFixed(2);
//         toast.error(
//           t(
//             "text.fileSizeExceeded",
//             `File size (${fileSizeInMB}MB) exceeds the maximum allowed limit of 50MB. Please select a smaller file.`
//           )
//         );
//         event.target.value = "";
//         setfileName("");
//         setPreviewUrl("");
//         setFileNameWithoutExt("");
//         setOriginalExtension("");
//         setIsDetectingAttachmentType(false);
//         setCurrentAttachmentAiSuggestion(null);
//         return;
//       }

//       // Validate file type
//       if (!isValidFileType(file)) {
//         toast.error(t("text.invalidFileType", "Only PDF, JPEG, and PNG files are allowed"));
//         event.target.value = "";
//         return;
//       }

//       // Convert to base64
//       const reader = new FileReader();
//       reader.onload = () => {
//         setPdfBase64(reader.result as string);
//       };
//       reader.readAsDataURL(file);

//       const currentFileName = file.name;
//       const extIndex = currentFileName.lastIndexOf('.');
//       const withoutExt = extIndex !== -1 ? currentFileName.substring(0, extIndex) : currentFileName;
//       const ext = extIndex !== -1 ? currentFileName.substring(extIndex) : '';
//       const previewUrlLocal = URL.createObjectURL(file);
      
//       setPreviewUrl(previewUrlLocal);
//       setfileName(currentFileName);
//       setFileNameWithoutExt(withoutExt);
//       setOriginalExtension(ext);
//       setCurrentAttachmentAiSuggestion(null);
//       setIsDetectingAttachmentType(true);
      
//       try {
//          //@ts-ignore
//         const detectedLabel = await simulateAIDocumentTypeDetection("", currentFileName, t);
//         setCurrentAttachmentAiSuggestion(detectedLabel);
//         if (detectedLabel) { 
//           toast.info(t("text.aiAttachmentCategorySuggestion", `AI suggests category: ${detectedLabel}`), { autoClose: 3500 }); 
//         } else { 
//           toast.info(t("text.aiNoSpecificCategoryForAttachment", "AI couldn't suggest a specific category."), { autoClose: 3000 }); 
//         }
//       } catch (aiError) { 
//         console.error("AI attachment category detection error:", aiError); 
//         toast.error(t("text.aiDetectionError")); 
//       } finally { 
//         setIsDetectingAttachmentType(false); 
//       }
//     } else {
//       setfileName(""); 
//       setPreviewUrl(""); 
//       setFileNameWithoutExt(""); 
//       setOriginalExtension("");
//       setIsDetectingAttachmentType(false); 
//       setCurrentAttachmentAiSuggestion(null);
//     }
//   };

//   const addMoreRow = () => {
//     if (!fileName || !pDate) { 
//       toast.warn(t("text.PleaseFillAttachmentDetails")); 
//       return; 
//     }
//     if (isDetectingAttachmentType) { 
//       toast.warn(t("text.fileProcessingWait")); 
//       return; 
//     }
    
//     const newRow = {
//       id: tableData.length + 1,
//       pdFid: -1,
//       pdfName: fileName,
//       docMid: -1,
//       keywords: keywords,
//       subFtype: "",
//       pDate: pDate,
//       isMain: "",
//       entryDate: defaultValues,
//       user_id: -1,
//       pdfPath: pdfBase64,
//       pdfView: previewUrl,
//       srn: -1,
//       isDelete: false,
//     };

//     setTableData((prevTableData: any) => {
//       const updatedTableDataed = [...prevTableData, newRow];
//       return updatedTableDataed;
//     });

//     setfileName("");
//     setPreviewUrl("");
//     setPDate(today || "");
//     setKeywords("");
//     setFileNameWithoutExt("");
//     setOriginalExtension("");
//     setPdfBase64("");
//     setCurrentAttachmentAiSuggestion(null);
    
//     const fileInput = document.getElementById('pdf_attach_file_input') as HTMLInputElement;
//     if (fileInput) fileInput.value = "";
//   };

//   const removeExtraRow = (id: any) => {
//     setTableData((prevTableData: any) => {
//       const updatedTableDataed = prevTableData.filter(
//         (row: any) => row.id !== id
//       );
//       return updatedTableDataed;
//     });
//   };

//   const back = useNavigate();

//   const getAutocompleteValue = (options: SelectOption[], formikValue: string | null | number): SelectOption | null => {
//     if (formikValue === null || formikValue === undefined) return null;
//     return options.find(option => String(option.value) === String(formikValue)) || null;
//   };

//   const handleReset = () => {
//     formik.resetForm();
//     setPDate(today || ""); 
//     setKeywords(""); 
//     setfileName(""); 
//     setPreviewUrl("");
//     setFileNameWithoutExt(""); 
//     setOriginalExtension("");
//     setPdfBase64("");
//     setCurrentAttachmentAiSuggestion(null); 
//     setIsDetectingAttachmentType(false);
    
//     const fileInput = document.getElementById('pdf_attach_file_input') as HTMLInputElement;
//     if (fileInput) fileInput.value = "";
//   };

//   // Function to get the correct PDF source for display
//   const getPdfSource = (row: any) => {
//     return row.pdfView || "";
//   };

//   return (
//     <div>
//       <ToastApp />
//       {loader && (
//         <Box
//           sx={{
//             position: "fixed",
//             top: 0,
//             left: 0,
//             width: "100vw",
//             height: "100vh",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             backgroundColor: "rgba(255, 255, 255, 0.7)",
//             zIndex: (theme) => theme.zIndex.drawer + 50,
//           }}
//         >
//           <Box
//             sx={{
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "center",
//               padding: 4,
//               backgroundColor: "rgba(255,255,255,0.95)",
//               borderRadius: "12px",
//               boxShadow: "0 8px 32px 0 rgba(31, 38, 135, 0.37)",
//               border: "1px solid rgba(255, 255, 255, 0.18)",
//             }}
//           >
//             <img
//               src="../../../assets/images/qq.png"
//               alt="Loading..."
//               style={{
//                 width: "120px",
//                 height: "auto",
//                 marginBottom: "24px",
//                 animation: "pulse 1.5s infinite ease-in-out",
//               }}
//             />
//             <LinearProgress
//               color="primary"
//               sx={{
//                 width: "200px",
//                 height: "8px",
//                 borderRadius: "4px",
//                 backgroundColor: "rgba(0, 123, 255, 0.1)",
//                 "& .MuiLinearProgress-bar": { borderRadius: "4px" },
//               }}
//             />
//             <Typography
//               variant="subtitle1"
//               sx={{ marginTop: 2, color: "text.secondary" }}
//             >
//               {t("text.processing", "Processing, please wait...")}
//             </Typography>
//           </Box>
//         </Box>
//       )}

//       <div
//         style={{
//           padding: "-5px 5px",
//           backgroundColor: "#ffffff",
//           borderRadius: "5px",
//           marginTop: "3vh",
//           filter: loader ? "blur(5px)" : "none",
//           pointerEvents: loader ? "none" : "auto",
//           transition: "filter 0.3s ease-out",
//         }}
//       >
//         <CardContent>
//           <Typography
//             variant="h5"
//             textAlign="center"
//             style={{ fontSize: "18px", fontWeight: 500 }}
//           >
//             {t("text.DocumentEntryEdit", "Document Entry Edit")}
//           </Typography>
//           <Grid item sm={4} xs={12} style={{ marginTop: "-40px" }}>
//             <Button
//               type="button"
//               onClick={() => back(-1)}
//               variant="contained"
//               style={{
//                 backgroundColor: `var(--header-background)`,
//                 minWidth: "40px",
//                 padding: "5px 0",
//               }}
//             >
//               <ArrowBackSharpIcon />
//             </Button>
//           </Grid>
//           <Divider style={{ marginTop: "10px", marginBottom: "20px" }} />
          
//           <form onSubmit={formik.handleSubmit}>
//             <Grid container spacing={2}>
//               <Grid item lg={4} sm={6} xs={12}>
//                 <TextField
//                   id="fileNo"
//                   name="fileNo"
//                   label={
//                     <span>
//                       {t("text.EnterFileNo", "File No")}{" "}
//                       <span
//                         style={{
//                           color:
//                             formik.values.fileNo && !formik.errors.fileNo
//                               ? "green"
//                               : "red",
//                         }}
//                       >
//                         *
//                       </span>
//                     </span>
//                   }
//                   value={formik.values.fileNo}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   error={formik.touched.fileNo && Boolean(formik.errors.fileNo)}
//                   helperText={
//                     formik.touched.fileNo && (formik.errors.fileNo as string)
//                   }
//                   size="small"
//                   fullWidth
//                   style={{ backgroundColor: "white" }}
//                 />
//               </Grid>
//               <Grid item lg={4} sm={6} xs={12}>
//                 <TextField
//                   id="synopsis"
//                   name="synopsis"
//                   label={
//                     <span>
//                       {t("text.FileName", "File Name/Synopsis")}{" "}
//                       <span
//                         style={{
//                           color:
//                             formik.values.synopsis && !formik.errors.synopsis
//                               ? "green"
//                               : "red",
//                         }}
//                       >
//                         *
//                       </span>
//                     </span>
//                   }
//                   value={formik.values.synopsis}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   error={
//                     formik.touched.synopsis && Boolean(formik.errors.synopsis)
//                   }
//                   helperText={
//                     formik.touched.synopsis &&
//                     (formik.errors.synopsis as string)
//                   }
//                   size="small"
//                   fullWidth
//                   style={{ backgroundColor: "white" }}
//                 />
//               </Grid>
//               <Grid item lg={4} sm={6} xs={12}>
//                 <TextField
//                   id="fileDef"
//                   name="fileDef"
//                   label={t("text.EnterFileDef", "File Definition")}
//                   value={formik.values.fileDef}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   size="small"
//                   fullWidth
//                   style={{ backgroundColor: "white" }}
//                 />
//               </Grid>
//               <Grid item lg={4} sm={6} xs={12}>
//                 <TextField
//                   id="perFr"
//                   name="perFr"
//                   label={t("text.EnterPeriodFileFrom", "Period From")}
//                   value={formik.values.perFr}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   InputLabelProps={{ shrink: true }}
//                   size="small"
//                   type="date"
//                   fullWidth
//                   style={{ backgroundColor: "white" }}
//                 />
//               </Grid>
//               <Grid item lg={4} sm={6} xs={12}>
//                 <TextField
//                   id="perUt"
//                   name="perUt"
//                   label={t("text.EnterPeriodFileUpto", "Period Upto")}
//                   value={formik.values.perUt}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   InputLabelProps={{ shrink: true }}
//                   size="small"
//                   type="date"
//                   fullWidth
//                   style={{ backgroundColor: "white" }}
//                 />
//               </Grid>
//               <Grid item lg={4} sm={6} xs={12}>
//                 <TextField
//                   id="authPersn"
//                   name="authPersn"
//                   label={t(
//                     "text.EnterAuthenticatePerson",
//                     "Authenticate Person"
//                   )}
//                   value={formik.values.authPersn}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   size="small"
//                   fullWidth
//                   style={{ backgroundColor: "white" }}
//                 />
//               </Grid>
//               <Grid item lg={4} sm={6} xs={12}>
//                 <TextField
//                   id="fDate"
//                   name="fDate"
//                   label={t("text.EnterFileDate", "File Date")}
//                   value={formik.values.fDate}
//                   onChange={formik.handleChange}
//                   onBlur={formik.handleBlur}
//                   InputLabelProps={{ shrink: true }}
//                   size="small"
//                   type="date"
//                   fullWidth
//                   style={{ backgroundColor: "white" }}
//                 />
//               </Grid>
//               <Grid item lg={4} sm={6} xs={12}>
//                 <Autocomplete
//                   disablePortal
//                   id="fileTypId"
//                   options={TypeOption}
//                   value={getAutocompleteValue(
//                     TypeOption,
//                     formik.values.fileTypId
//                   )}
//                   getOptionLabel={(option) => option.label}
//                   isOptionEqualToValue={(option, value) =>
//                     String(option.value) === String(value?.value)
//                   }
//                   onChange={(event, newValue) => {
//                     formik.setFieldValue(
//                       "fileTypId",
//                       newValue ? String(newValue.value) : null
//                     );
//                   }}
//                   onBlur={() => formik.setFieldTouched("fileTypId", true)}
//                   fullWidth
//                   size="small"
//                   renderInput={(params) => (
//                     <TextField
//                       {...params}
//                       name="fileTypId"
//                       label={
//                         <span>
//                           {t("text.SelectFileType", "Select File Type")}{" "}
//                           <span
//                             style={{
//                               color:
//                                 formik.values.fileTypId &&
//                                   !formik.errors.fileTypId
//                                   ? "green"
//                                   : "red",
//                             }}
//                           >
//                             *
//                           </span>
//                         </span>
//                       }
//                       error={
//                         formik.touched.fileTypId &&
//                         Boolean(formik.errors.fileTypId)
//                       }
//                       helperText={
//                         formik.touched.fileTypId &&
//                         (formik.errors.fileTypId as string)
//                       }
//                     />
//                   )}
//                 />
//               </Grid>
//               <Grid item lg={4} sm={6} xs={12}>
//                 <Autocomplete
//                   disablePortal
//                   id="subsubjId"
//                   options={Subject}
//                   value={getAutocompleteValue(Subject, formik.values.subsubjId)}
//                   getOptionLabel={(option) => option.label}
//                   isOptionEqualToValue={(option, value) =>
//                     String(option.value) === String(value?.value)
//                   }
//                   onChange={(event, newValue) => {
//                     formik.setFieldValue(
//                       "subsubjId",
//                       newValue ? String(newValue.value) : null
//                     );
//                   }}
//                   onBlur={() => formik.setFieldTouched("subsubjId", true)}
//                   fullWidth
//                   size="small"
//                   renderInput={(params) => (
//                     <TextField
//                       {...params}
//                       name="subsubjId"
//                       label={
//                         <span>
//                           {t("text.SelectSubject", "Select Subject")}{" "}
//                           <span
//                             style={{
//                               color:
//                                 formik.values.subsubjId &&
//                                   !formik.errors.subsubjId
//                                   ? "green"
//                                   : "red",
//                             }}
//                           >
//                             *
//                           </span>
//                         </span>
//                       }
//                       error={
//                         formik.touched.subsubjId &&
//                         Boolean(formik.errors.subsubjId)
//                       }
//                       helperText={
//                         formik.touched.subsubjId &&
//                         (formik.errors.subsubjId as string)
//                       }
//                     />
//                   )}
//                 />
//               </Grid>
//               <Grid item lg={4} sm={6} xs={12}>
//                 <Autocomplete
//                   disablePortal
//                   id="divisionid"
//                   options={Division}
//                   value={getAutocompleteValue(
//                     Division,
//                     formik.values.divisionid
//                   )}
//                   getOptionLabel={(option) => option.label}
//                   isOptionEqualToValue={(option, value) =>
//                     String(option.value) === String(value?.value)
//                   }
//                   onChange={(event, newValue) => {
//                     formik.setFieldValue(
//                       "divisionid",
//                       newValue ? String(newValue.value) : null
//                     );
//                     if (newValue?.value) {
//                       getSubDepartment(Number(newValue?.value || -1))
//                     } else {
//                       getSubDepartment();
//                     }
//                   }}
//                   onBlur={() => formik.setFieldTouched("divisionid", true)}
//                   fullWidth
//                   size="small"
//                   renderInput={(params) => (
//                     <TextField
//                       {...params}
//                       name="divisionid"
//                       label={
//                         <span>
//                           {t(
//                             "text.SelectDepartment",
//                             "Select Division/Department"
//                           )}{" "}
//                           <span
//                             style={{
//                               color:
//                                 formik.values.divisionid &&
//                                   !formik.errors.divisionid
//                                   ? "green"
//                                   : "red",
//                             }}
//                           >
//                             *
//                           </span>
//                         </span>
//                       }
//                       error={
//                         formik.touched.divisionid &&
//                         Boolean(formik.errors.divisionid)
//                       }
//                       helperText={
//                         formik.touched.divisionid &&
//                         (formik.errors.divisionid as string)
//                       }
//                     />
//                   )}
//                 />
//               </Grid>
//               <Grid item lg={4} sm={6} xs={12}>
//                 <Autocomplete
//                   disablePortal
//                   id="subDeptID"
//                   options={subDepartments}
//                   value={getAutocompleteValue(
//                     subDepartments,
//                     formik.values.subDeptID
//                   )}
//                   getOptionLabel={(option) => option.label}
//                   isOptionEqualToValue={(option, value) =>
//                     String(option.value) === String(value?.value)
//                   }
//                   onChange={(event, newValue) => {
//                     formik.setFieldValue(
//                       "subDeptID",
//                       newValue ? String(newValue.value) : null
//                     );
//                   }}
//                   onBlur={() => formik.setFieldTouched("subDeptID", true)}
//                   fullWidth
//                   size="small"
//                   renderInput={(params) => (
//                     <TextField
//                       {...params}
//                       name="subDeptID"
//                       label={
//                         <span>
//                           {t("text.SelectSubDept", "Select Sub Department")}
//                         </span>
//                       }
//                     />
//                   )}
//                 />
//               </Grid>

//               <Grid item xs={12}>
//                 <Divider sx={{ marginY: 2 }}>
//                   <Typography variant="subtitle1">
//                     {t("text.Attachments", "Attachments")}*
//                   </Typography>
//                 </Divider>
//               </Grid>

//               <Grid item container xs={12} spacing={2} alignItems="flex-start">
//                 <Grid item xs={12} lg={2.5}>
//                   <TextField
//                     label={t("text.PeriodDate", "Period Date")}
//                     value={pDate}
//                     onChange={(e: any) => setPDate(e.target.value)}
//                     InputLabelProps={{ shrink: true }}
//                     size="small"
//                     type="date"
//                     fullWidth
//                   />
//                 </Grid>
//                 <Grid item xs={12} lg={2}>
//                   <TextField
//                     label={t("text.Keywords", "Keywords")}
//                     value={keywords}
//                     onChange={(e: any) => setKeywords(e.target.value)}
//                     size="small"
//                     fullWidth
//                   />
//                 </Grid>

//                 <Grid item xs={12} lg={3}>
//                   <TextField
//                     id="pdf_attach_file_input"
//                     name="pdf_attach_input"
//                     label={t("text.AttachedFile", "Attach File")}
//                     onChange={onTransctionChange}
//                     size="small"
//                     type="file"
//                     fullWidth
//                     style={{ backgroundColor: "white" }}
//                     InputLabelProps={{ shrink: true }}
//                     inputProps={{
//                       accept: ".pdf,application/pdf"
//                     }}
//                   />
//                   <Typography variant="caption" display="block" sx={{ mt: 0.5, color: 'text.secondary' }}>
//                     {t("text.allowedFileTypes", "Only PDF files are allowed")} (Max: 50MB)
//                   </Typography>

//                   {fileName && previewUrl && (
//                     <Typography variant="caption" display="block" sx={{ mt: 0.5, color: 'text.secondary' }}>
//                       {t("text.fileSize", "File Size")}: {formatFileSize(pdfBase64 ? pdfBase64.length * 0.75 : 0)} (Max: 50MB)
//                     </Typography>
//                   )}

//                   {isDetectingAttachmentType && fileName && (
//                     <Box sx={{ width: '100%', mt: 0.5 }}>
//                       <LinearProgress variant="indeterminate" />
//                       <Typography variant="caption" display="block" textAlign="center" sx={{ color: 'text.secondary' }}>
//                         {t("text.aiDetectingAttachmentCategory", "AI Detecting Category...")}
//                       </Typography>
//                     </Box>
//                   )}
//                   {currentAttachmentAiSuggestion && !isDetectingAttachmentType && fileName && (
//                     <Box sx={{ mt: 0.5, p: 0.5, display: 'flex', alignItems: 'center', backgroundColor: 'rgba(0,0,0,0.03)', borderRadius: 1 }}>
//                       <AiIcon fontSize="small" sx={{ mr: 0.5, color: 'text.secondary' }} />
//                       <Typography variant="caption" component="span" sx={{ fontStyle: 'italic', color: 'text.secondary' }}>
//                         {t("text.aiSuggestsCategory", "AI Suggests Category:")} {currentAttachmentAiSuggestion}
//                       </Typography>
//                     </Box>
//                   )}
//                 </Grid>

//                 <Grid item xs={12} lg={3}>
//                   <TextField
//                     id="fileName_display"
//                     name="fileName_display"
//                     label={t("text.EnterFileName", "Selected File")}
//                     value={fileNameWithoutExt}
//                     onChange={(e) => {
//                       let input = e.target.value.trim();
//                       input = input.replace(
//                         /\.(pdf|docx?|xlsx?|xlsm|pptx?|txt|csv|jpg|jpeg|png|gif|bmp|tiff|zip|rar|7z|tar|gz|exe|dll|bat|cmd|msi|apk|mp3|mp4|avi|mkv|mov|flv|html|htm|js|css|json|xml|iso|bin|img|db|sql|log|tmp|ini)$/i,
//                         ""
//                       );
//                       const forcedExt = ".pdf";
//                       setFileNameWithoutExt(input);
//                       setOriginalExtension(forcedExt);
//                       setfileName(input + forcedExt);
//                     }}
//                     size="small"
//                     fullWidth
//                     style={{ backgroundColor: "white" }}
//                     InputProps={{
//                       endAdornment: originalExtension ? (
//                         <InputAdornment
//                           position="end"
//                           disableTypography
//                           sx={{
//                             pointerEvents: "none",
//                             userSelect: "none",
//                             color: "green",
//                             fontWeight: "bold"
//                           }}
//                         >
//                           {originalExtension}
//                         </InputAdornment>
//                       ) : null,
//                     }}
//                     InputLabelProps={{
//                       shrink: Boolean(fileNameWithoutExt || originalExtension),
//                     }}
//                     error={fileName ? !fileName.toLowerCase().endsWith(".pdf") : false}
//                     helperText={
//                       fileName && !fileName.toLowerCase().endsWith(".pdf")
//                         ? t("text.onlyPdfAllowed", "Only .pdf extension is allowed")
//                         : t("text.fileNameHelp", "You can edit the filename (keep .pdf extension)")
//                     }
//                   />
//                 </Grid>
//                 <Grid item xs={12} lg={1.5}>
//                   <Button
//                     startIcon={<AddCircleIcon />}
//                     variant="contained"
//                     color="info"
//                     fullWidth
//                     onClick={addMoreRow}
//                     disabled={!fileName || !pDate || isDetectingAttachmentType}
//                   >
//                     {t("text.add", "Add")}
//                   </Button>
//                 </Grid>
//               </Grid>

//               {tableData.length > 0 && (
//                 <Grid
//                   item
//                   xs={12}
//                   sx={{ marginTop: "15px", overflowX: "auto" }}
//                 >
//                   <Table
//                     style={{
//                       borderCollapse: "collapse",
//                       width: "100%",
//                       border: "1px solid #ddd",
//                     }}
//                     size="small"
//                   >
//                     <thead style={{ backgroundColor: "#e0e0e0" }}>
//                       <tr>
//                         <th style={{ border: "1px solid #ddd", padding: "8px" }}>
//                           {t("text.Action", "Action")}
//                         </th>
//                         <th style={{ border: "1px solid #ddd", padding: "8px" }}>
//                           {t("text.PeriodDate", "Period Date")}
//                         </th>
//                         <th style={{ border: "1px solid #ddd", padding: "8px" }}>
//                           {t("text.Keywords", "Keywords")}
//                         </th>
//                         <th style={{ border: "1px solid #ddd", padding: "8px" }}>
//                           {t("text.FileName", "File Name")}
//                         </th>
//                         <th style={{ border: "1px solid #ddd", padding: "8px" }}>
//                           {t("text.PdfFile", "PDF File")}
//                         </th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {tableData?.map((row: any) => (
//                         <tr key={row.id}>
//                           <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>
//                             <DeleteIcon
//                               style={{ color: "darkred", cursor: "pointer" }}
//                               onClick={() => removeExtraRow(row.id)}
//                             />
//                           </td>
//                           <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>
//                             {row.pDate ? moment(row.pDate).format("DD-MM-YYYY") : "-"}
//                           </td>
//                           <td style={{ border: "1px solid #ddd", padding: "8px" }}>
//                             {row.keywords || "-"}
//                           </td>
//                           <td style={{ border: "1px solid #ddd", padding: "8px" }}>
//                             {row.pdfName}
//                           </td>
//                           <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>
//                             {getPdfSource(row) ? (
//                               <Typography
//                                 onClick={() => modalOpenHandle1(getPdfSource(row))}
//                                 sx={{
//                                   color: "primary.main",
//                                   cursor: "pointer",
//                                   textDecoration: "underline",
//                                 }}
//                               >
//                                 {t("text.Preview", "Preview")}
//                               </Typography>
//                             ) : (
//                               t("text.NoPreview", "No Preview")
//                             )}
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </Table>

//                   <Modal
//                     open={Opens}
//                     onClose={handlePanClose1}
//                     aria-labelledby="modal-title"
//                   >
//                     <Box sx={style}>
//                       {Img ? (
//                         <embed
//                           src={Img}
//                           type="application/pdf"
//                           style={{
//                             width: "100%",
//                             height: "100%",
//                             minHeight: "500px",
//                           }}
//                         />
//                       ) : (
//                         <Box sx={{ display: "flex", justifyContent: "center" }}>
//                           <img
//                             src={nopdf}
//                             alt="No PDF"
//                             style={{ maxWidth: "80%" }}
//                           />
//                         </Box>
//                       )}
//                     </Box>
//                   </Modal>
//                 </Grid>
//               )}

//               <Grid
//                 item
//                 xs={12}
//                 container
//                 spacing={2}
//                 justifyContent="center"
//                 style={{ marginTop: "20px" }}
//               >
//                 <Grid item xs={12} sm={4} md={3}>
//                   <Button
//                     type="submit"
//                     variant="contained"
//                     fullWidth
//                     style={{
//                       backgroundColor: `var(--header-background)`,
//                       color: "white",
//                     }}
//                     disabled={loader || formik.isSubmitting}
//                   >
//                     {formik.isSubmitting ? (
//                       <CircularProgress size={24} color="inherit" />
//                     ) : (
//                       t("text.update", "Update")
//                     )}
//                   </Button>
//                 </Grid>
//                 <Grid item xs={12} sm={4} md={3}>
//                   <Button
//                     type="button"
//                     variant="contained"
//                     fullWidth
//                     style={{ backgroundColor: "#F43F5E", color: "white" }}
//                     disabled={loader || formik.isSubmitting}
//                     onClick={handleReset}
//                   >
//                     {t("text.reset", "Reset")}
//                   </Button>
//                 </Grid>
//               </Grid>
//             </Grid>
//           </form>
//         </CardContent>
//       </div>
//     </div>
//   );
// };

// export default DocumentEntryEdit;






import {
  Button,
  CardContent,
  Grid,
  TextField,
  Typography,
  Divider,
  Modal,
  Box,
  Table,
  CircularProgress,
  LinearProgress,
  InputAdornment,
} from "@mui/material";
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import HOST_URL from "../../../utils/Url";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import Autocomplete from "@mui/material/Autocomplete";
import nopdf from "../../../assets/images/nopdf.png";
import dayjs from "dayjs";
import moment from "moment";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import AiIcon from '@mui/icons-material/Psychology';
import { getSecureDevId } from "../../../utils/storageHelpers";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80vw",
  height: "85vh",
  bgcolor: "background.paper",
  border: "1px solid #000",
  boxShadow: 24,
  p: 4,
  borderRadius: "10px",
  overflowY: 'auto',
};

type Props = {};

interface SelectOption { value: string | number; label: string; }

const MAX_FILE_SIZE = 50 * 1024 * 1024; // 50MB

const documentContentKeywords: Record<string, { keywords: string[], typeLabel: string, threshold: number, regex?: RegExp[] }> = {
  FLEET_VEHICLE_REPORT: {
    keywords: ["vehicle data", "vehicle no", "vehicle type", "time consumption", "fuel consumpt", "tipper", "dumper", "loader", "skid steer", "tata", "leyland", "truck", "hrs", "mins", "sec", "mt"],
    regex: [/[A-Z]{2}\s?\d{1,2}\s?[A-Z]{0,3}\s?\/?\s?\d{1,4}/i, /CH\.?NO\.?\s?\d+/i],
    typeLabel: "Fleet Report / Vehicle Data",
    threshold: 4
  },
  RESUME: { keywords: ["resume", "cv", "curriculum vitae", "experience", "education", "skills", "objective", "summary", "references", "career", "employment history", "qualification"], typeLabel: "Resume/CV", threshold: 2 },
  INVOICE: { keywords: ["invoice", "bill", "receipt", "amount due", "invoice #", "invoice number", "bill to", "ship to", "item", "quantity", "price", "total", "tax", "vat", "payment terms"], typeLabel: "Invoice/Bill", threshold: 2 },
  LETTER: { keywords: ["dear", "sincerely", "yours faithfully", "regards", "letter", "correspondence", "enclosed", "subject:", "to whom it may concern"], typeLabel: "Letter/Correspondence", threshold: 2 },
  NEWS_ARTICLE: { keywords: ["news", "article", "headline", "byline", "published", "edition", "column", "editorial", "reporter", "source", "dateline", "breaking news", "journal"], typeLabel: "News Article/Publication", threshold: 2 },
  AGREEMENT: { keywords: ["agreement", "contract", "terms and conditions", "party a", "party b", "whereas", "heretofore", "witnesseth", "binding", "legal", "nda", "memorandum of understanding"], typeLabel: "Agreement/Contract", threshold: 2 },
  REPORT: { keywords: ["report", "summary", "analysis", "findings", "conclusion", "executive summary", "introduction", "methodology", "research", "study", "annual report"], typeLabel: "General Report/Summary", threshold: 2 },
  FORM: { keywords: ["form", "application", "please fill", "submit", "signature", "date of birth", "personal details", "declaration"], typeLabel: "Form/Application", threshold: 2 },
  PRESENTATION: { keywords: ["presentation", "slides", "powerpoint", "keynote", "deck", "slide deck"], typeLabel: "Presentation", threshold: 1 },
  SPREADSHEET: { keywords: ["spreadsheet", "excel", "sheet", "workbook", "data", "table", "csv"], typeLabel: "Spreadsheet/Data", threshold: 1 },
};

const simulateAIDocumentTypeDetection = async (
  _base64Pdf: string,
  currentFileName: string,
  t: (key: string, defaultValue?: string) => string
): Promise<string | null> => {
  return new Promise((resolve) => {
    const contentToAnalyze = currentFileName.toLowerCase().replace(/[_-]/g, " ");

    setTimeout(() => {
      let detectedTypeLabel: string | null = null;
      let bestMatchScore = 0;
      let bestMatchKey: string | null = null;

      for (const docKey in documentContentKeywords) {
        const { keywords, threshold, regex } = documentContentKeywords[docKey];
        let currentScore = 0;

        if (regex && regex.length > 0) {
          for (const r of regex) {
            if (r.test(contentToAnalyze)) { currentScore += 3; break; }
          }
        }
        for (const keyword of keywords) {
          if (contentToAnalyze.includes(keyword)) { currentScore++; }
        }
        if (currentScore >= threshold && currentScore > bestMatchScore) { bestMatchScore = currentScore; bestMatchKey = docKey; }
      }

      if (bestMatchKey) {
        detectedTypeLabel = documentContentKeywords[bestMatchKey].typeLabel;
      } else {
        if (currentFileName.toLowerCase().endsWith(".pdf")) { detectedTypeLabel = t("text.aiGenericDocument", "Generic Document"); }
      }
      resolve(detectedTypeLabel);
    }, 1500);
  });
};

const isValidFileType = (file: File): boolean => {
  const allowedMimeTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg'];
  const allowedExtensions = ['.pdf', '.jpeg', '.jpg', '.png'];

  const fileName = file.name.toLowerCase();
  const extensionCount = (fileName.match(/\./g) || []).length;

  if (extensionCount > 1) return false;

  const fileExtension = fileName.substring(fileName.lastIndexOf('.'));
  if (!allowedExtensions.includes(fileExtension)) return false;

  if (!allowedMimeTypes.includes(file.type)) return false;

  if (file.type === 'application/x-msdownload' ||
    file.type === 'application/x-dosexec' ||
    file.type === 'application/x-executable' ||
    file.name.endsWith('.exe') ||
    file.name.endsWith('.bat') ||
    file.name.endsWith('.cmd') ||
    file.name.endsWith('.sh')) {
    return false;
  }

  return true;
};

const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

const DocumentEntryEdit = (props: Props) => {
  var someDate = new Date();
  var date = someDate.setDate(someDate.getDate());
  var defaultValues = new Date(date).toISOString().split("T")[0];

  const today = moment().format("YYYY-MM-DD");
  const { t } = useTranslation();

  const [TypeOption, setTypeOption] = useState<SelectOption[]>([]);
  const [Subject, setSubject] = useState<SelectOption[]>([]);
  const [Division, setDivision] = useState<SelectOption[]>([]);
  const [subDepartments, setSubDepartments] = useState<SelectOption[]>([]);
  const [userRole, setUserRole] = useState<string>("");
  const [currentDeptId, setCurrentDeptId] = useState<number>(-1);

  const [Opens, setOpen] = React.useState(false);
  const [Img, setImg] = useState<any>("");
  const [loader, setLoader] = useState(false);

  const [tableData, setTableData] = useState<any>([]);
  const [pDate, setPDate] = useState(today || "");
  const [keywords, setKeywords] = useState("");
  const [fileName, setfileName] = useState("");
  const [previewUrl, setPreviewUrl] = useState("");
  const [fileNameWithoutExt, setFileNameWithoutExt] = useState("");
  const [originalExtension, setOriginalExtension] = useState("");
  const [pdfBase64, setPdfBase64] = useState("");
  const [isDetectingAttachmentType, setIsDetectingAttachmentType] = useState(false);
  const [currentAttachmentAiSuggestion, setCurrentAttachmentAiSuggestion] = useState<string | null>(null);

  const handlePanClose1 = () => { setOpen(false); };
  const modalOpenHandle1 = (event: any) => { setOpen(true); setImg(event); };

  const devId = getSecureDevId();
  const initialDivisionId = devId === null || devId === undefined ? "" : Number(devId);

  let navigate = useNavigate();
  const location = useLocation();

  const validationSchema = Yup.object({
    fileNo: Yup.string().required(t("text.reqFileNo", "File No is required")),
    subsubjId: Yup.string().nullable().required(t("text.reqsubsubjId", "Subject is required")),
    divisionid: Yup.string().nullable().required(t("text.reqdivisionid", "Division is required")),
    fileTypId: Yup.string().nullable().required(t("text.reqfileTypeID", "File Type is required")),
    member_DocFiles: Yup.array().min(1, t("text.reqAttachment", "At least one attachment is required")).required(t("text.reqAttachment", "Attachment is required")),
  });

  const formik = useFormik({
    initialValues: {
      docMid: location.state?.docMid || "",
      fileDef: location.state?.fileDef || "",
      fileNo: location.state?.fileNo || "",
      synopsis: location.state?.synopsis || "",
      status: location.state?.status || "",
      fileType: location.state?.fileType || "",
      subj: location.state?.subj || "",
      complt: location.state?.complt || "",
      fDate: location.state?.fDate ? dayjs(location.state.fDate).format("YYYY-MM-DD") : today,
      partNo: location.state?.partNo || "",
      pFileNo: location.state?.pFileNo ? dayjs(location.state.pFileNo).format("YYYY-MM-DD") : today,
      perFr: location.state?.perFr ? dayjs(location.state.perFr).format("YYYY-MM-DD") : today,
      perUt: location.state?.perUt ? dayjs(location.state.perUt).format("YYYY-MM-DD") : today,
      authPersn: location.state?.authPersn || "",
      fileTypId: location.state?.fileTypId ? String(location.state.fileTypId) : null,
      subsubjId: location.state?.subsubjId ? String(location.state.subsubjId) : null,
      sub_Subject_Name: location.state?.sub_Subject_Name || "",
      divisionid: location.state?.divisionid ? String(location.state.divisionid) : null,
      subDeptID: location.state?.subDeptID ? String(location.state.subDeptID) : null,
      createdate: location.state?.createdate || today,
      user_Id: location.state?.user_Id || 1,
      userId: location.state?.userId || "",
      member_DocFiles: [],
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      let firstFileName = tableData.length > 0 ? tableData[0].keywords || tableData[0].pdfName || "Document" : "Document";

      const submissionValues = {
        ...values,
        synopsis: firstFileName,
        fileDef: firstFileName,
        perFr: tableData.length > 0 ? tableData[0].pDate : today,
        perUt: tableData.length > 0 ? tableData[0].pDate : today,
        member_DocFiles: tableData,
      };

      if (!submissionValues.member_DocFiles || submissionValues.member_DocFiles.length === 0) {
        toast.error(t("text.reqAttachment"));
        return;
      }

      setLoader(true);
      try {
        const response = await axios.post(
          HOST_URL.HOST_URL2 + `DocMangr/AddUpdateDocMangr`,
          submissionValues
        );
        if (response.data.isSuccess) {
          toast.success(response.data.mesg);
          setLoader(false);
          setTimeout(() => navigate("/DocManagement/DocumentEntry"), 1000);
        } else {
          toast.error(response.data.mesg);
          setLoader(false);
        }
      } catch (error) {
        console.error("Error submitting form:", error);
        toast.error(t("text.ErrorSubmittingForm"));
        setLoader(false);
      }
    },
  });

  const getFileType = (deptId: number = -1) => {
    const collectData = { docID: -1, parentDocId: deptId, userId: "" };
    axios
      .post(HOST_URL.HOST_URL2 + `OtherDocType/GetOtherDocType`, collectData)
      .then((res) => {
        const arr: SelectOption[] = res?.data?.data?.map((item: any) => ({
          label: item.doc_Name,
          value: String(item.docID),
        })) || [];
        setTypeOption(arr);
      })
      .catch((error) => {
        console.error("Error fetching file types:", error);
        toast.error(t("text.ErrorFetchingFileTypes"));
      });
  };

  const getSubject = () => {
    const collectData = { sID: -1 };
    axios
      .post(HOST_URL.HOST_URL2 + `SubjectMasterForPdf/GetSubjectMasterForPdf`, collectData)
      .then((res) => {
        const arr: SelectOption[] = res.data.data.map((item: any) => ({
          label: item.subject,
          value: String(item.sId),
        })) || [];
        setSubject(arr);
      })
      .catch((error) => {
        console.error("Error fetching subjects:", error);
        toast.error(t("text.ErrorFetchingSubjects"));
      });
  };

  const getDivision = () => {
    const collectData = { id: initialDivisionId === "" ? -1 : initialDivisionId, nodeID: -1, titleID: -1 };
    axios
      .post(HOST_URL.HOST_URL2 + `NewNodeMaster/GetNewNodeMaster`, collectData)
      .then((res) => {
        const arr: SelectOption[] = res.data.data.map((item: any) => ({
          label: item.name,
          value: String(item.id),
        })) || [];
        setDivision(arr);
      })
      .catch((error) => {
        console.error("Error fetching divisions:", error);
        toast.error(t("text.ErrorFetchingDivisions"));
      });
  };

  const getSubDepartment = (deptId: number = -1, subDeptId: number = -1) => {
    const collectData = { "subDeptID": subDeptId, "deptID": deptId };
    axios
      .post(HOST_URL.HOST_URL2 + `SubDepartmentMaster/GetSubDepartmentMaster`, collectData)
      .then((res) => {
        const arr: SelectOption[] = res.data.data.map((item: any) => ({
          label: item.subDeptName,
          value: String(item.subDeptID),
        })) || [];
        setSubDepartments(arr);
      })
      .catch((error) => {
        console.error("Error fetching sub departments:", error);
        toast.error(t("text.ErrorFetchingDivisions"));
      });
  };

  const getDocManagerbyID = async () => {
    const collectData = {
      docMid: location.state?.docMid || -1,
      fileTypId: -1,
      divisionid: -1,
      subsubjId: -1,
      user_Id: -1,
      fileNo: "",
      subDeptID: -1,
      synopsis: "",
      complt: ""
    };
    await axios
      .post(HOST_URL.HOST_URL2 + `DocMangr/GetDocMangr`, collectData)
      .then((res) => {
        var member_DocFiles;
        for (let index = 0; index < res.data.data?.length; index++) {
          member_DocFiles = res.data.data[index]["member_DocFiles"];
          const arrtabledata = [];
          for (let index = 0; index < member_DocFiles?.length; index++) {
            arrtabledata.push({
              id: index + 1,
              pdFid: member_DocFiles[index]["pdFid"] || "",
              pdfName: member_DocFiles[index]["pdfName"] || "",
              docMid: member_DocFiles[index]["docMid"] || "",
              keywords: member_DocFiles[index]["keywords"] || "",
              subFtype: member_DocFiles[index]["subFtype"] || "",
              pDate: moment(member_DocFiles[index]["pDate"] || "").format("YYYY-MM-DD"),
              isMain: member_DocFiles[index]["isMain"] || "",
              entryDate: member_DocFiles[index]["entryDate"] || "",
              user_id: member_DocFiles[index]["user_id"] || "",
              pdfPath: member_DocFiles[index]["pdfPath"] || "",
              pdfView: member_DocFiles[index]["pdfPath"] || "",
              srn: -1,
              isDelete: member_DocFiles[index]["isDelete"] || "",
            });
          }
          setTableData(arrtabledata);
        }
      });
  };

  useEffect(() => {
    let userRoleLocal = "";
    let userDeptId = -1;
    let userSubDeptId = -1;

    try {
      const userData = JSON.parse(localStorage.getItem("userdetail") || "[]");
      if (userData && userData.length > 0) {
        const user = userData[0];
        userRoleLocal = user.roleName || user.role || "";
        userDeptId = user.deptId || user.departmentId || user.empDeptId || -1;
        userSubDeptId = user.subDeptId || user.subDepartmentId || user.empSubDeptId || -1;

        setUserRole(userRoleLocal);
        setCurrentDeptId(userDeptId);
      }
    } catch (error) {
      console.error("Error getting user data:", error);
    }

    const isAdmin = userRoleLocal?.toLowerCase() === "admin" || userRoleLocal?.toLowerCase() === "administrator";
    const filterDeptId = isAdmin ? -1 : userDeptId;
    const filterSubDeptId = isAdmin ? -1 : userSubDeptId;

    getFileType(filterDeptId);
    getSubject();
    getDivision();
    getSubDepartment(userDeptId, filterSubDeptId);
    getDocManagerbyID();
  }, []);

  useEffect(() => {
    if (formik.values.divisionid) {
      const deptId = Number(formik.values.divisionid);
      const isAdmin = userRole?.toLowerCase() === "admin" || userRole?.toLowerCase() === "administrator";
      const filterDeptId = isAdmin ? -1 : deptId;
      getFileType(filterDeptId);
      const filterSubDeptId = isAdmin ? -1 : currentDeptId;
      getSubDepartment(deptId, filterSubDeptId);
    }
  }, [formik.values.divisionid, userRole]);

  const onTransctionChange = async (event: any) => {
    event.preventDefault();
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];

      if (file.size > MAX_FILE_SIZE) {
        const fileSizeInMB = (file.size / (1024 * 1024)).toFixed(2);
        toast.error(t("text.fileSizeExceeded", `File size (${fileSizeInMB}MB) exceeds the maximum allowed limit of 50MB.`));
        event.target.value = "";
        setfileName(""); setPreviewUrl(""); setFileNameWithoutExt(""); setOriginalExtension("");
        setIsDetectingAttachmentType(false); setCurrentAttachmentAiSuggestion(null);
        return;
      }

      if (!isValidFileType(file)) {
        toast.error(t("text.invalidFileType", "Only PDF, JPEG, and PNG files are allowed"));
        event.target.value = "";
        return;
      }

      const reader = new FileReader();
      reader.onload = () => { setPdfBase64(reader.result as string); };
      reader.readAsDataURL(file);

      const currentFileName = file.name;
      const extIndex = currentFileName.lastIndexOf('.');
      const withoutExt = extIndex !== -1 ? currentFileName.substring(0, extIndex) : currentFileName;
      const ext = extIndex !== -1 ? currentFileName.substring(extIndex) : '';
      const previewUrlLocal = URL.createObjectURL(file);
      
      setPreviewUrl(previewUrlLocal);
      setfileName(currentFileName);
      setFileNameWithoutExt(withoutExt);
      setOriginalExtension(ext);
      setCurrentAttachmentAiSuggestion(null);
      setIsDetectingAttachmentType(true);

      formik.setFieldValue("synopsis", withoutExt);
      formik.setFieldValue("fileDef", withoutExt);
      formik.setFieldValue("perFr", today);
      formik.setFieldValue("perUt", today);
      
      try {
        //@ts-ignore
        const detectedLabel = await simulateAIDocumentTypeDetection("", currentFileName, t);
        setCurrentAttachmentAiSuggestion(detectedLabel);
      } catch (aiError) {
        console.error("AI error:", aiError);
      } finally {
        setIsDetectingAttachmentType(false);
      }
    } else {
      setfileName(""); setPreviewUrl(""); setFileNameWithoutExt(""); setOriginalExtension("");
      setIsDetectingAttachmentType(false); setCurrentAttachmentAiSuggestion(null);
    }
  };

  const addMoreRow = () => {
    if (!fileName || !pDate) { toast.warn(t("text.PleaseFillAttachmentDetails")); return; }
    if (isDetectingAttachmentType) { toast.warn(t("text.fileProcessingWait")); return; }

    formik.setFieldValue("synopsis", fileNameWithoutExt);
    formik.setFieldValue("fileDef", fileNameWithoutExt);
    formik.setFieldValue("perFr", pDate);
    formik.setFieldValue("perUt", pDate);
    
    const newRow = {
      id: tableData.length + 1,
      pdFid: -1,
      pdfName: fileName,
      docMid: -1,
      keywords: fileNameWithoutExt,
      subFtype: "",
      pDate: pDate,
      isMain: "Y",
      entryDate: defaultValues,
      user_id: -1,
      pdfPath: pdfBase64,
      pdfView: previewUrl,
      srn: -1,
      isDelete: false,
    };

    setTableData((prevTableData: any) => [...prevTableData, newRow]);

    setfileName("");
    setPreviewUrl("");
    setPDate(today || "");
    setFileNameWithoutExt("");
    setOriginalExtension("");
    setPdfBase64("");
    setCurrentAttachmentAiSuggestion(null);
    
    const fileInput = document.getElementById('pdf_attach_file_input') as HTMLInputElement;
    if (fileInput) fileInput.value = "";
  };

  const removeExtraRow = (id: any) => {
    setTableData((prevTableData: any) => prevTableData.filter((row: any) => row.id !== id));
  };

  const back = useNavigate();

  const getAutocompleteValue = (options: SelectOption[], formikValue: string | null | number): SelectOption | null => {
    if (formikValue === null || formikValue === undefined) return null;
    return options.find(option => String(option.value) === String(formikValue)) || null;
  };

  const handleReset = () => {
    formik.resetForm();
    setPDate(today || ""); setKeywords(""); setfileName(""); setPreviewUrl("");
    setFileNameWithoutExt(""); setOriginalExtension(""); setPdfBase64("");
    setCurrentAttachmentAiSuggestion(null); setIsDetectingAttachmentType(false);
    const fileInput = document.getElementById('pdf_attach_file_input') as HTMLInputElement;
    if (fileInput) fileInput.value = "";
  };

  const getPdfSource = (row: any) => { return row.pdfView || ""; };

  return (
    <div>
      <ToastApp />
      {loader && (
        <Box
          sx={{
            position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh",
            display: "flex", justifyContent: "center", alignItems: "center",
            backgroundColor: "rgba(255, 255, 255, 0.7)", zIndex: (theme) => theme.zIndex.drawer + 50,
          }}
        >
          <Box
            sx={{
              display: "flex", flexDirection: "column", alignItems: "center", padding: 4,
              backgroundColor: "rgba(255,255,255,0.95)", borderRadius: "12px",
              boxShadow: "0 8px 32px 0 rgba(31, 38, 135, 0.37)", border: "1px solid rgba(255, 255, 255, 0.18)",
            }}
          >
            <img
              src="../../../assets/images/qq.png"
              alt="Loading..."
              style={{ width: "120px", height: "auto", marginBottom: "24px", animation: "pulse 1.5s infinite ease-in-out" }}
            />
            <LinearProgress
              color="primary"
              sx={{ width: "200px", height: "8px", borderRadius: "4px", backgroundColor: "rgba(0, 123, 255, 0.1)", "& .MuiLinearProgress-bar": { borderRadius: "4px" } }}
            />
            <Typography variant="subtitle1" sx={{ marginTop: 2, color: "text.secondary" }}>
              {t("text.processing", "Processing, please wait...")}
            </Typography>
          </Box>
        </Box>
      )}

      <div
        style={{
          padding: "-5px 5px", backgroundColor: "#ffffff", borderRadius: "5px", marginTop: "3vh",
          filter: loader ? "blur(5px)" : "none", pointerEvents: loader ? "none" : "auto", transition: "filter 0.3s ease-out",
        }}
      >
        <CardContent>
          <Typography variant="h5" textAlign="center" style={{ fontSize: "18px", fontWeight: 500 }}>
            {t("text.DocumentEntryEdit", "Document Entry Edit")}
          </Typography>
          <Grid item sm={4} xs={12} style={{ marginTop: "-40px" }}>
            <Button
              type="button"
              onClick={() => back(-1)}
              variant="contained"
              style={{ backgroundColor: `var(--header-background)`, minWidth: "40px", padding: "5px 0" }}
            >
              <ArrowBackSharpIcon />
            </Button>
          </Grid>
          <Divider style={{ marginTop: "10px", marginBottom: "20px" }} />
          
          <form onSubmit={formik.handleSubmit}>
            <Grid container spacing={2}>
              {/* 1. File No (Disabled) */}
              <Grid item lg={4} sm={6} xs={12}>
                <TextField
                  id="fileNo"
                  name="fileNo"
                  label={t("text.EnterFileNo", "File No")}
                  value={formik.values.fileNo}
                  disabled
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "#f5f5f5" }}
                />
              </Grid>

              {/* 2. Division / Department */}
              <Grid item lg={4} sm={6} xs={12}>
                <Autocomplete
                  disablePortal
                  id="divisionid"
                  options={Division}
                  value={getAutocompleteValue(Division, formik.values.divisionid)}
                  getOptionLabel={(option) => option.label}
                  isOptionEqualToValue={(option, value) => String(option.value) === String(value?.value)}
                  onChange={(event, newValue) => {
                    formik.setFieldValue("divisionid", newValue ? String(newValue.value) : null);
                    if (newValue?.value) { getSubDepartment(Number(newValue?.value || -1)); } 
                    else { getSubDepartment(); }
                  }}
                  onBlur={() => formik.setFieldTouched("divisionid", true)}
                  fullWidth
                  size="small"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="divisionid"
                      label={
                        <span>
                          {t("text.SelectDepartment", "Select Division/Department")}{" "}
                          <span style={{ color: formik.values.divisionid && !formik.errors.divisionid ? "green" : "red" }}>*</span>
                        </span>
                      }
                      error={formik.touched.divisionid && Boolean(formik.errors.divisionid)}
                      helperText={formik.touched.divisionid && (formik.errors.divisionid as string)}
                    />
                  )}
                />
              </Grid>

              {/* 3. Sub Department */}
              <Grid item lg={4} sm={6} xs={12}>
                <Autocomplete
                  disablePortal
                  id="subDeptID"
                  options={subDepartments}
                  value={getAutocompleteValue(subDepartments, formik.values.subDeptID)}
                  getOptionLabel={(option) => option.label}
                  isOptionEqualToValue={(option, value) => String(option.value) === String(value?.value)}
                  onChange={(event, newValue) => {
                    formik.setFieldValue("subDeptID", newValue ? String(newValue.value) : null);
                  }}
                  onBlur={() => formik.setFieldTouched("subDeptID", true)}
                  fullWidth
                  size="small"
                  renderInput={(params) => (
                    <TextField {...params} name="subDeptID" label={t("text.SelectSubDept", "Select Sub Department")} />
                  )}
                />
              </Grid>

              {/* 4. File Type */}
              <Grid item lg={4} sm={6} xs={12}>
                <Autocomplete
                  disablePortal
                  id="fileTypId"
                  options={TypeOption}
                  value={getAutocompleteValue(TypeOption, formik.values.fileTypId)}
                  getOptionLabel={(option) => option.label}
                  isOptionEqualToValue={(option, value) => String(option.value) === String(value?.value)}
                  onChange={(event, newValue) => {
                    formik.setFieldValue("fileTypId", newValue ? String(newValue.value) : null);
                  }}
                  onBlur={() => formik.setFieldTouched("fileTypId", true)}
                  fullWidth
                  size="small"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="fileTypId"
                      label={
                        <span>
                          {t("text.SelectFileType", "Select File Type")}{" "}
                          <span style={{ color: formik.values.fileTypId && !formik.errors.fileTypId ? "green" : "red" }}>*</span>
                        </span>
                      }
                      error={formik.touched.fileTypId && Boolean(formik.errors.fileTypId)}
                      helperText={formik.touched.fileTypId && (formik.errors.fileTypId as string)}
                    />
                  )}
                />
              </Grid>

              {/* 5. Subject */}
              <Grid item lg={4} sm={6} xs={12}>
                <Autocomplete
                  disablePortal
                  id="subsubjId"
                  options={Subject}
                  value={getAutocompleteValue(Subject, formik.values.subsubjId)}
                  getOptionLabel={(option) => option.label}
                  isOptionEqualToValue={(option, value) => String(option.value) === String(value?.value)}
                  onChange={(event, newValue) => {
                    formik.setFieldValue("subsubjId", newValue ? String(newValue.value) : null);
                  }}
                  onBlur={() => formik.setFieldTouched("subsubjId", true)}
                  fullWidth
                  size="small"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="subsubjId"
                      label={
                        <span>
                          {t("text.SelectSubject", "Select Subject")}{" "}
                          <span style={{ color: formik.values.subsubjId && !formik.errors.subsubjId ? "green" : "red" }}>*</span>
                        </span>
                      }
                      error={formik.touched.subsubjId && Boolean(formik.errors.subsubjId)}
                      helperText={formik.touched.subsubjId && (formik.errors.subsubjId as string)}
                    />
                  )}
                />
              </Grid>

              {/* 6. Authenticate Person */}
              <Grid item lg={4} sm={6} xs={12}>
                <TextField
                  id="authPersn"
                  name="authPersn"
                  label={t("text.EnterAuthenticatePerson", "Authenticate Person")}
                  value={formik.values.authPersn}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                />
              </Grid>

              {/* 7. File Date */}
              <Grid item lg={4} sm={6} xs={12}>
                <TextField
                  id="fDate"
                  name="fDate"
                  label={t("text.EnterFileDate", "File Date")}
                  value={formik.values.fDate}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  InputLabelProps={{ shrink: true }}
                  size="small"
                  type="date"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                />
              </Grid>

              <Grid item xs={12}>
                <Divider sx={{ marginY: 2 }}>
                  <Typography variant="subtitle1">{t("text.Attachments", "Attachments")}*</Typography>
                </Divider>
              </Grid>

              <Grid item container xs={12} spacing={2} alignItems="flex-start">
                {/* Attach File Input */}
                <Grid item xs={12} lg={4}>
                  <TextField
                    id="pdf_attach_file_input"
                    name="pdf_attach_input"
                    label={t("text.AttachedFile", "Attach File")}
                    onChange={onTransctionChange}
                    size="small"
                    type="file"
                    fullWidth
                    style={{ backgroundColor: "white" }}
                    InputLabelProps={{ shrink: true }}
                    inputProps={{ accept: ".pdf,application/pdf" }}
                  />
                  <Typography variant="caption" display="block" sx={{ mt: 0.5, color: 'text.secondary' }}>
                    {t("text.allowedFileTypes", "Only PDF files are allowed")} (Max: 50MB)
                  </Typography>

                  {fileName && previewUrl && (
                    <Typography variant="caption" display="block" sx={{ mt: 0.5, color: 'text.secondary' }}>
                      {t("text.fileSize", "File Size")}: {formatFileSize(pdfBase64 ? pdfBase64.length * 0.75 : 0)} (Max: 50MB)
                    </Typography>
                  )}

                  {isDetectingAttachmentType && fileName && (
                    <Box sx={{ width: '100%', mt: 0.5 }}>
                      <LinearProgress variant="indeterminate" />
                      <Typography variant="caption" display="block" textAlign="center" sx={{ color: 'text.secondary' }}>
                        {t("text.aiDetectingAttachmentCategory", "AI Detecting Category...")}
                      </Typography>
                    </Box>
                  )}
                  {currentAttachmentAiSuggestion && !isDetectingAttachmentType && fileName && (
                    <Box sx={{ mt: 0.5, p: 0.5, display: 'flex', alignItems: 'center', backgroundColor: 'rgba(0,0,0,0.03)', borderRadius: 1 }}>
                      <AiIcon fontSize="small" sx={{ mr: 0.5, color: 'text.secondary' }} />
                      <Typography variant="caption" component="span" sx={{ fontStyle: 'italic', color: 'text.secondary' }}>
                        {t("text.aiSuggestsCategory", "AI Suggests Category:")} {currentAttachmentAiSuggestion}
                      </Typography>
                    </Box>
                  )}
                </Grid>

                {/* Selected File Name Display (Disabled) */}
                <Grid item xs={12} lg={6}>
                  <TextField
                    id="fileName_display"
                    name="fileName_display"
                    label={t("text.EnterFileName", "Selected File Name")}
                    value={fileNameWithoutExt}
                    disabled
                    size="small"
                    fullWidth
                    style={{ backgroundColor: "#f5f5f5" }}
                    InputProps={{
                      endAdornment: originalExtension ? (
                        <InputAdornment
                          position="end"
                          disableTypography
                          sx={{ pointerEvents: "none", userSelect: "none", color: "green", fontWeight: "bold" }}
                        >
                          {originalExtension}
                        </InputAdornment>
                      ) : null,
                    }}
                    InputLabelProps={{ shrink: Boolean(fileNameWithoutExt || originalExtension) }}
                  />
                </Grid>

                {/* Add Button */}
                <Grid item xs={12} lg={2}>
                  <Button
                    startIcon={<AddCircleIcon />}
                    variant="contained"
                    color="info"
                    fullWidth
                    onClick={addMoreRow}
                    disabled={!fileName || !pDate}
                  >
                    {t("text.add", "Add")}
                  </Button>
                </Grid>
              </Grid>

              {tableData.length > 0 && (
                <Grid item xs={12} sx={{ marginTop: "15px", overflowX: "auto" }}>
                  <Table style={{ borderCollapse: "collapse", width: "100%", border: "1px solid #ddd" }} size="small">
                    <thead style={{ backgroundColor: "#e0e0e0" }}>
                      <tr>
                        <th style={{ border: "1px solid #ddd", padding: "8px" }}>{t("text.Action", "Action")}</th>
                        <th style={{ border: "1px solid #ddd", padding: "8px" }}>{t("text.PeriodDate", "Period Date")}</th>
                        <th style={{ border: "1px solid #ddd", padding: "8px" }}>{t("text.Keywords", "Keywords")}</th>
                        <th style={{ border: "1px solid #ddd", padding: "8px" }}>{t("text.FileName", "File Name")}</th>
                        <th style={{ border: "1px solid #ddd", padding: "8px" }}>{t("text.PdfFile", "PDF File")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tableData?.map((row: any) => (
                        <tr key={row.id}>
                          <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>
                            <DeleteIcon
                              style={{ color: "darkred", cursor: "pointer" }}
                              onClick={() => removeExtraRow(row.id)}
                            />
                          </td>
                          <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>
                            {row.pDate ? moment(row.pDate).format("DD-MM-YYYY") : "-"}
                          </td>
                          <td style={{ border: "1px solid #ddd", padding: "8px" }}>{row.keywords || "-"}</td>
                          <td style={{ border: "1px solid #ddd", padding: "8px" }}>{row.pdfName}</td>
                          <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>
                            {getPdfSource(row) ? (
                              <Typography
                                onClick={() => modalOpenHandle1(getPdfSource(row))}
                                sx={{ color: "primary.main", cursor: "pointer", textDecoration: "underline" }}
                              >
                                {t("text.Preview", "Preview")}
                              </Typography>
                            ) : (
                              t("text.NoPreview", "No Preview")
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>

                  <Modal open={Opens} onClose={handlePanClose1} aria-labelledby="modal-title">
                    <Box sx={style}>
                      {Img ? (
                        <embed
                          src={Img}
                          type="application/pdf"
                          style={{ width: "100%", height: "100%", minHeight: "500px" }}
                        />
                      ) : (
                        <Box sx={{ display: "flex", justifyContent: "center" }}>
                          <img src={nopdf} alt="No PDF" style={{ maxWidth: "80%" }} />
                        </Box>
                      )}
                    </Box>
                  </Modal>
                </Grid>
              )}

              <Grid item xs={12} container spacing={2} justifyContent="center" style={{ marginTop: "20px" }}>
                <Grid item xs={12} sm={4} md={3}>
                  <Button
                    type="submit"
                    variant="contained"
                    fullWidth
                    style={{ backgroundColor: `var(--header-background)`, color: "white" }}
                    disabled={loader || formik.isSubmitting}
                  >
                    {formik.isSubmitting ? (<CircularProgress size={24} color="inherit" />) : (t("text.update", "Update"))}
                  </Button>
                </Grid>
                <Grid item xs={12} sm={4} md={3}>
                  <Button
                    type="button"
                    variant="contained"
                    fullWidth
                    style={{ backgroundColor: "#F43F5E", color: "white" }}
                    disabled={loader || formik.isSubmitting}
                    onClick={handleReset}
                  >
                    {t("text.reset", "Reset")}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </div>
    </div>
  );
};

export default DocumentEntryEdit;